// extracted by mini-css-extract-plugin
export default {"formHeading":"lK-z","form":"mK-z","submitBtn":"nK-z","disabled":"oK-z","input":"pK-z","error":"qK-z","submitMsg":"rK-z","signIn":"sK-z"};